import createTheme from '../../createTheme';

const theme = createTheme({});

export default theme;
